import React, { Component } from "react";
import ArchiveChaptersPanel from "./ArchiveChaptersPanel";

export default class ArchivedChaptersPanel extends Component {
  render() {
    const { chapters = [], ...rest } = this.props;

    return (
      <ArchiveChaptersPanel
        {...rest}
        title="Archive"
        emptyText="Archive is empty"
        sectionStatus="archived"
        chapters={chapters}
      />
    );
  }
}
